var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{staticStyle:{"padding":"0"},attrs:{"id":"medical-records-modal","hide-header":"","hide-footer":"","centered":"","size":"xl"},on:{"show":_vm.resetModulesFilter}},[_c('div',{staticClass:"history-container",attrs:{"id":"history-container"}},[_c('AttendanceHistory',{attrs:{"patientId":_vm.patientId,"hideBurger":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }